module.exports = __webpack_public_path__ + "templates/food.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/restaurant/templates/food.html
// module id = 03QO
// module chunks = 1